// extracted by mini-css-extract-plugin
export default {"container":"acc_2iLjn","icon":"acc_ico_335vK"};